import { render, staticRenderFns } from "./tableTd.vue?vue&type=template&id=40318ca2&"
import script from "./tableTd.vue?vue&type=script&lang=js&"
export * from "./tableTd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports